import { HTTP } from "@/utils/http-common"

export default {
  async getAll(queryArgs = null) {
    const path = `/account/admin/api-users`
    let results = (await HTTP.get(path, { params: queryArgs })).data
    results.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
    return results
  },

  async get(actionId) {
    const path = `/account/admin/api-users/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(data) {
    const path = `/account/admin/api-users`
    return (await HTTP.post(path, data)).data
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/account/admin/api-users/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(actionId) {
    const path = `/account/admin/api-users/${actionId}`
    return (await HTTP.delete(path)).data
  }
}
